import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../api/axiosInstance';
import axios from 'axios';
// Async thunk to get contract details
export const getContractDetails = createAsyncThunk(
  'contract/getContractDetails',
  async ({ contractId, token, language }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/Customer/GetContractDetails?id=${contractId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,  // Ensure the token is included
          'Accept': 'text/plain',
          'Content-Type': 'application/json-patch+json',
          'lang': language === 'English' ? '2' : '1', // Language parameter
        }
      });
      return response.data; // Return the response data
    } catch (error) {
      return rejectWithValue(error.response?.data?.errormessage || error.message);
    }
  }
);

// Slice for contract details
const contractDetailsSlice = createSlice({
  name: 'contract',
  initialState: {
    loading: false,
    error: null,
    contractDetails: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContractDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.contractDetails = action.payload;
      })
      .addCase(getContractDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contractDetailsSlice.reducer;
